import { useToast } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { InvitationRead } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdateInvitedUserListQuery } from "@/queries/query-user-invited";

export type RevokeUserInviteArgs = {
  invitations: InvitationRead[];
};

export const useRevokeUserInvites = () => {
  const toast = useToast();
  const intl = useIntl();
  const updateInvitedUserListQuery = useUpdateInvitedUserListQuery();

  return useMutationWithErrorHandler(async ({ invitations }: RevokeUserInviteArgs) => {
    const promises = invitations.map(async ({ id }) => {
      const result = await getRanaApiV1().InvitationsApi.revokeInvitation({ invitationId: id });
      updateInvitedUserListQuery(result.id, result);
    });

    await Promise.all(promises);

    toast({
      title: intl.formatMessage({
        id: "success",
        defaultMessage: "Success!",
      }),
      description: intl.formatMessage({
        id: "success.revoked_invite",
        defaultMessage: "Successfully revoked invites.",
      }),
    });
  });
};
